<template>
  <div>
    <h2>我报名的活动</h2>
    <a-divider></a-divider>
    <div class="pannel">
      <a-button type="danger" @click="toOrder()" icon="right-circle">查看我的订单</a-button>
      <a-list :dataSource="dataSource" :pagination="pagination" :locale="{emptyText: '暂无报名的活动'}">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="item-card" >
            <a-row :gutter="24">
              <a-col :sm="8" :xs="24">
                <div class="img-zoom" @click="toEventDetail(item)">
                  <img class="cover" :src="item.eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col :sm="12" :xs="24">
                <h2>{{item.eventName}} 
                <a-tag>{{item.eventType_dictText}}</a-tag>
                <a-tag color="red" v-if="item.applyStatus==0">未支付</a-tag>
                <a-tag color="red" v-if="item.applyStatus==-1">已退费</a-tag>
                </h2>
                <p>赛项：{{getDictValue(item.myEventCategoryPid)}} 组别：{{getDictValue(item.myEventCategory)}}</p>
                <p>报名开始时间：{{item.eventBegin}}</p>
                <p>报名截止时间：{{item.eventEnd}}</p>
              </a-col>
              <a-col v-if="item.applyStatus >= 0" :sm="4" :xs="24" class="event-opts">
                <!-- <a-button type="dashed" @click="toEventDetail(item)">活动详情</a-button> -->
                <a-button @click="showApplyEvent(item)">报名信息</a-button>
                <a-button v-if="item.ticketId" type="dashed" @click="download(item.ticketUrl)">准考证</a-button>
                <a-button v-if="item.applyStatus==1 && item.takePartType==1" type="primary" @click="showSubmitWork(item)">{{item.worksVOS.length>0?'查看作品':'作品提交'}}</a-button>
                <a-button v-if="item.applyStatus==1 && item.takePartType==0 && item.examStatus > 0" :type="item.examStatus==2?'danger':'primary'" @click="toPaper(item)">{{item.examStatus==2?'去测评':'测评模拟'}}</a-button>
                <!-- <a-button v-if="item.canQueryScore" @click="toScore(item.eventApplyId)">测评成绩</a-button> -->
                <a-button v-if="item.certId&&item.certId!='-1'" @click="toCert(item.certId)">测评证书</a-button>
              </a-col>
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <EventApplyModal ref="applyModal"/>
    <SubmitWorkModal ref="submitModal" @ok="submitOk"/>
  </div>
</template>

<script>

import "@/assets/less/animation.css";
import { getAction, postAction } from "@/api/manage";
import EventApplyModal from "../modal/EventApplyModal"
import SubmitWorkModal from "../modal/SubmitWorkModal"
import {filterMultiDictText} from '@/components/jeecg/JDictSelectUtil'
import { loadCategoryData } from '@/api/api'
export default {
  name: "Event",
  components:{
    EventApplyModal,
    SubmitWorkModal
  },
  data() {
    return {
      dataSource: [],
      dictOptions: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 6,
      },
    };
  },
  created() {
    loadCategoryData({code:"A05"}).then((res) => {
      if (res.success) {
        this.$set(this.dictOptions, 'eventCategory', res.result)
      }
    })
    this.getMyApplyEvent()
  },
  methods:{
    getDictValue(text){
      return filterMultiDictText(this.dictOptions['eventCategory'], text)
    },
    getMyApplyEvent(){
      getAction("/teaching/teachingEventApply/myApply").then((res) => {
        if (res.success) {
          this.dataSource = res.result;
        }
      });
    },
    toEventDetail(item){
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.eventId,
        },
      });
      window.open(route.href, '_blank');
    },
    download(url){
      window.open(url + "?t="+new Date().getTime())
    },
    toOrder(){
      this.$router.push({path: '/user/order'})
    },
    submitOk(){
      this.getMyApplyEvent()
    },
    showApplyEvent(applyInfo){
      this.$refs.applyModal.open(applyInfo.eventId, applyInfo.myEventCategory)
    },
    showSubmitWork(info){
      if(info.takePartType == 2){
        this.$success({
          title: "提示",
          content: (
            <div>
              <p>线下活动报名成功后直接提示凭证件前往！</p>
            </div>
          ),
        });
      }else{
        this.$refs.submitModal.open(info)
      }
    },
    toPaper(item){
      let route = this.$router.resolve({
        path: "/examine",
        query: {
          eaid: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
    toScore(eventApplyId){
      window.open("/cert/score.html?id="+eventApplyId)
    },
    toCert(certId){
      window.open("/cert/query?id="+certId)
    }
  }
};
</script>

<style lang="less" scoped>
.pannel{
  .item-card{
    .cover{
      width: 100%;
    }
    .event-opts{
      .ant-btn{
        margin: 8px 0;
      }
      
    }
  }

}
</style>